export function formatPercentage(value, showZeroIfNan  = false) {
    if (!value) {
        if (showZeroIfNan) return `0%`;
        return "";
    }

    return (
        (value / 10000).toLocaleString("en-GB", {
            style: 'percent',
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
        })
    );
}
